/**
 * Shared MUI `sx` tokens for table column filter menus (layout, typography, colors).
 * Centralizes All/Clear placement and font colors for `UnifiedColumnSortFilter` and consumers.
 */
import type { SxProps, Theme } from '@mui/material/styles';
import { SEARCE_COLORS } from '../../../theme';

export const columnFilterMenuPaperSx: SxProps<Theme> = {
  width: 252,
  maxWidth: 280,
  minWidth: 236,
  maxHeight: 380,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const columnFilterMenuListSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  p: 0,
};

export const columnFilterTabsSx: SxProps<Theme> = {
  borderBottom: 1,
  borderColor: 'divider',
  minHeight: 34,
  flexShrink: 0,
  '& .MuiTab-root': { minHeight: 34, py: 0 },
};

export const columnFilterTabSx: SxProps<Theme> = {
  fontSize: '0.7rem',
  minHeight: 34,
  textTransform: 'none',
};

/** "Filter {title}" row — title uses primary text color */
export const columnFilterSectionTitleSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: '0.74rem',
  lineHeight: 1.2,
  minWidth: 0,
  color: SEARCE_COLORS.textPrimary,
};

/** All / Clear in header — same neutral text as body actions (not primary blue) */
export const columnFilterHeaderActionButtonSx: SxProps<Theme> = {
  fontSize: '0.64rem',
  minWidth: 'auto',
  px: 0.5,
  py: 0.1,
  minHeight: 26,
  lineHeight: 1.2,
  textTransform: 'none',
  color: SEARCE_COLORS.textSecondary,
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const columnFilterSearchFieldSx: SxProps<Theme> = {
  mb: 1,
  '& .MuiInputBase-input': { py: 0.65, fontSize: '0.75rem' },
};

export const columnFilterOptionRowTypographySx: SxProps<Theme> = {
  fontSize: '0.68rem',
  minWidth: 0,
  wordBreak: 'break-word',
  color: SEARCE_COLORS.textPrimary,
};

export const columnFilterEmptyTypographySx: SxProps<Theme> = {
  textAlign: 'center',
  py: 2,
  color: SEARCE_COLORS.textSecondary,
  fontSize: '0.75rem',
};

export const columnFilterFooterSecondaryButtonSx: SxProps<Theme> = {
  fontSize: '0.64rem',
  py: 0.15,
  minHeight: 28,
  textTransform: 'none',
  color: SEARCE_COLORS.textSecondary,
};

export const columnFilterFooterPrimaryButtonSx: SxProps<Theme> = {
  fontSize: '0.64rem',
  py: 0.15,
  minHeight: 28,
  textTransform: 'none',
  backgroundColor: SEARCE_COLORS.primary,
  '&:hover': {
    backgroundColor: '#0056cc',
  },
};

export const columnFilterSortHintSx: SxProps<Theme> = {
  mb: 0.75,
  fontSize: '0.68rem',
  color: SEARCE_COLORS.textSecondary,
};

export const columnFilterCaptionSx: SxProps<Theme> = {
  mb: 0.5,
  display: 'block',
  color: SEARCE_COLORS.textSecondary,
  fontSize: '0.65rem',
};

export const columnFilterSortAscDescButtonSx: SxProps<Theme> = {
  fontSize: '0.7rem',
  minHeight: 32,
  justifyContent: 'flex-start',
  textTransform: 'none',
};
